import { render } from "./PhoneMange.vue?vue&type=template&id=72e9de16&scoped=true"
import script from "./PhoneMange.vue?vue&type=script&lang=js"
export * from "./PhoneMange.vue?vue&type=script&lang=js"

import "./PhoneMange.vue?vue&type=style&index=0&id=72e9de16&lang=scss&scoped=true"
import "./PhoneMange.vue?vue&type=style&index=1&id=72e9de16&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e9de16"]])

export default __exports__